/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var TableManagementMode;
(function (TableManagementMode) {
    TableManagementMode["UNKNOWN"] = "UNKNOWN";
    TableManagementMode["ON"] = "ON";
    TableManagementMode["IN_HOUSE_ONLY"] = "IN_HOUSE_ONLY";
    TableManagementMode["OFF"] = "OFF";
})(TableManagementMode || (TableManagementMode = {}));
export var Unit;
(function (Unit) {
    Unit["UNKNOWN"] = "UNKNOWN";
    Unit["MINUTES"] = "MINUTES";
    Unit["HOURS"] = "HOURS";
    Unit["DAYS"] = "DAYS";
})(Unit || (Unit = {}));
export var ApprovalMode;
(function (ApprovalMode) {
    ApprovalMode["UNKNOWN"] = "UNKNOWN";
    ApprovalMode["AUTOMATIC"] = "AUTOMATIC";
    ApprovalMode["MANUAL"] = "MANUAL";
    ApprovalMode["MANUAL_FOR_LARGE_PARTIES"] = "MANUAL_FOR_LARGE_PARTIES";
})(ApprovalMode || (ApprovalMode = {}));
/** Type of the field. */
export var FieldType;
(function (FieldType) {
    FieldType["UNKNOWN"] = "UNKNOWN";
    FieldType["TABLE"] = "TABLE";
    FieldType["START_DATE"] = "START_DATE";
    FieldType["END_DATE"] = "END_DATE";
    FieldType["CREATED_DATE"] = "CREATED_DATE";
    FieldType["UPDATED_DATE"] = "UPDATED_DATE";
    FieldType["PARTY_SIZE"] = "PARTY_SIZE";
    FieldType["FIRST_NAME"] = "FIRST_NAME";
    FieldType["LAST_NAME"] = "LAST_NAME";
    FieldType["EMAIL"] = "EMAIL";
    FieldType["PHONE"] = "PHONE";
    FieldType["ADDITIONAL_INFO"] = "ADDITIONAL_INFO";
    FieldType["TEAM_MESSAGE"] = "TEAM_MESSAGE";
    FieldType["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    FieldType["STATUS"] = "STATUS";
})(FieldType || (FieldType = {}));
export var PaymentPolicyType;
(function (PaymentPolicyType) {
    PaymentPolicyType["UNKNOWN_PAYMENT_POLICY"] = "UNKNOWN_PAYMENT_POLICY";
    PaymentPolicyType["PER_GUEST"] = "PER_GUEST";
    PaymentPolicyType["PER_RESERVATION"] = "PER_RESERVATION";
})(PaymentPolicyType || (PaymentPolicyType = {}));
export var Set;
(function (Set) {
    /**
     * Returns `id`, `archived`, `location`, `default`, `configuration.onlineReservations.partiesSize`, `configuration.onlineReservations.minimumReservationNotice`, `configuration.onlineReservations.businessSchedule`,
     * `configuration.onlineReservations.showPhoneNumber`, `configuration.onlineReservations.onlineReservationsEnabled`, `configuration.onlineReservations.manualApproval`, `configuration.reservationForm.submitMessage`,
     * `configuration.reservationForm.policiesEnabled`, `configuration.reservationForm.termsAndConditions`, `configuration.reservationForm.privacyPolicy`,
     * `configuration.reservationForm.customFieldDefinitions`, `configuration.reservationForm.lastNameRequired`, `configuration.reservationForm.emailRequired`, `configuration.reservationForm.emailMarketingCheckbox`.
     */
    Set["PUBLIC"] = "PUBLIC";
    /** - `FULL`: Returns all fields. */
    Set["FULL"] = "FULL";
})(Set || (Set = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["RESERVATION_FIELD_NOT_EXIST"] = "RESERVATION_FIELD_NOT_EXIST";
    Type["RESERVATION_FIELD_MUST_HAVE_TYPE"] = "RESERVATION_FIELD_MUST_HAVE_TYPE";
    Type["CUSTOM_FIELD_NAMES_DUPLICATION"] = "CUSTOM_FIELD_NAMES_DUPLICATION";
    Type["CUSTOM_FIELD_IDS_DUPLICATION"] = "CUSTOM_FIELD_IDS_DUPLICATION";
    Type["TABLE_DEFINITION_NAMES_DUPLICATION"] = "TABLE_DEFINITION_NAMES_DUPLICATION";
    Type["TABLE_DEFINITION_IDS_DUPLICATION"] = "TABLE_DEFINITION_IDS_DUPLICATION";
    Type["TABLE_RESERVATION_INCORRECT_BOUNDARIES"] = "TABLE_RESERVATION_INCORRECT_BOUNDARIES";
    Type["TABLE_DEFINITION_NOT_EXIST"] = "TABLE_DEFINITION_NOT_EXIST";
    Type["TURNOVER_TIME_RULES_INTERSECT"] = "TURNOVER_TIME_RULES_INTERSECT";
    Type["TURNOVER_TIME_RULES_INCORRECT_BOUNDARIES"] = "TURNOVER_TIME_RULES_INCORRECT_BOUNDARIES";
    Type["MINIMUM_RESERVATION_NOTICE_PERIOD"] = "MINIMUM_RESERVATION_NOTICE_PERIOD";
    Type["TABLE_COMBINATION_IDS_DUPLICATION"] = "TABLE_COMBINATION_IDS_DUPLICATION";
    Type["TABLE_COMBINATION_TABLE_IDS_DUPLICATION"] = "TABLE_COMBINATION_TABLE_IDS_DUPLICATION";
    Type["TABLE_COMBINATION_TABLE_IDS_COMBINATION_DUPLICATION"] = "TABLE_COMBINATION_TABLE_IDS_COMBINATION_DUPLICATION";
    Type["TABLE_COMBINATION_NOT_EXIST"] = "TABLE_COMBINATION_NOT_EXIST";
    Type["TABLE_COMBINATION_CONTAINS_LESS_THAN_2_TABLES"] = "TABLE_COMBINATION_CONTAINS_LESS_THAN_2_TABLES";
    Type["TABLE_COMBINATION_MIN_MAX_SEATS"] = "TABLE_COMBINATION_MIN_MAX_SEATS";
    Type["NON_EXISTENT_TABLES_IN_TABLE_COMBINATION"] = "NON_EXISTENT_TABLES_IN_TABLE_COMBINATION";
    Type["PARTY_SIZE_AND_PARTIES_SIZE_ARE_DIFFERENT"] = "PARTY_SIZE_AND_PARTIES_SIZE_ARE_DIFFERENT";
    Type["TURNOVER_TIME_RULES_AND_TURNOVER_RULES_ARE_DIFFERENT"] = "TURNOVER_TIME_RULES_AND_TURNOVER_RULES_ARE_DIFFERENT";
    Type["TURNOVER_RULES_INTERSECT"] = "TURNOVER_RULES_INTERSECT";
    Type["TURNOVER_RULES_INCORRECT_BOUNDARIES"] = "TURNOVER_RULES_INCORRECT_BOUNDARIES";
    Type["PARTIES_SIZE_MIN_GREATER_THAN_MAX"] = "PARTIES_SIZE_MIN_GREATER_THAN_MAX";
    Type["PARTY_SIZE_MIN_GREATER_THAN_MAX"] = "PARTY_SIZE_MIN_GREATER_THAN_MAX";
    Type["BUSINESS_SCHEDULE_TIME_PERIOD_INVALID"] = "BUSINESS_SCHEDULE_TIME_PERIOD_INVALID";
    Type["BUSINESS_SCHEDULE_SPECIAL_HOUR_PERIOD_INVALID"] = "BUSINESS_SCHEDULE_SPECIAL_HOUR_PERIOD_INVALID";
    Type["MY_RESERVATIONS_FIELDS_DUPLICATION"] = "MY_RESERVATIONS_FIELDS_DUPLICATION";
    Type["TERMS_AND_CONDITIONS_VALUE_ABSENT"] = "TERMS_AND_CONDITIONS_VALUE_ABSENT";
    Type["PRIVACY_POLICY_VALUE_ABSENT"] = "PRIVACY_POLICY_VALUE_ABSENT";
    Type["DEFAULT_TURNOVER_TIME_ABSENT"] = "DEFAULT_TURNOVER_TIME_ABSENT";
    Type["NOT_ALL_RESERVATION_FIELDS"] = "NOT_ALL_RESERVATION_FIELDS";
    Type["TABLE_DEFINITION_INCORRECT_BOUNDARIES"] = "TABLE_DEFINITION_INCORRECT_BOUNDARIES";
    Type["BUSINESS_SCHEDULE_SPECIAL_HOUR_PERIOD_END_BEFORE_START"] = "BUSINESS_SCHEDULE_SPECIAL_HOUR_PERIOD_END_BEFORE_START";
    Type["BUSINESS_SCHEDULE_TIME_PERIOD_CLOSE_BEFORE_OPEN"] = "BUSINESS_SCHEDULE_TIME_PERIOD_CLOSE_BEFORE_OPEN";
    Type["MANUAL_APPROVAL_THRESHOLD_OUTSIDE_PARTY_SIZE"] = "MANUAL_APPROVAL_THRESHOLD_OUTSIDE_PARTY_SIZE";
    Type["APPROVAL_ABSENT"] = "APPROVAL_ABSENT";
    Type["MANUAL_APPROVAL_DEPRECATED"] = "MANUAL_APPROVAL_DEPRECATED";
    Type["APPROVAL_THRESHOLD_OUTSIDE_PARTY_SIZE"] = "APPROVAL_THRESHOLD_OUTSIDE_PARTY_SIZE";
    Type["APPROVAL_AND_MANUAL_APPROVAL_ARE_DIFFERENT"] = "APPROVAL_AND_MANUAL_APPROVAL_ARE_DIFFERENT";
    Type["MANUAL_APPROVAL_THRESHOLD_OUTSIDE_PARTIES_SIZE"] = "MANUAL_APPROVAL_THRESHOLD_OUTSIDE_PARTIES_SIZE";
    Type["PARTY_SIZE_ABSENT"] = "PARTY_SIZE_ABSENT";
    Type["PARTIES_SIZE_ABSENT"] = "PARTIES_SIZE_ABSENT";
    Type["TABLE_MANAGEMENT_MODE_ABSENT"] = "TABLE_MANAGEMENT_MODE_ABSENT";
    Type["PARTY_SIZE_THRESHOLD_ABSENT"] = "PARTY_SIZE_THRESHOLD_ABSENT";
    Type["CONSIDER_TABLES_FOR_MANUAL_APPROVAL_ABSENT"] = "CONSIDER_TABLES_FOR_MANUAL_APPROVAL_ABSENT";
    Type["APPROVAL_MODE_AND_OPTIONS_NOT_CORRESPOND"] = "APPROVAL_MODE_AND_OPTIONS_NOT_CORRESPOND";
    Type["RESERVATION_PAYMENT_DEPRECATED"] = "RESERVATION_PAYMENT_DEPRECATED";
    Type["MAXIMUM_RESERVATION_NOTICE_PERIOD"] = "MAXIMUM_RESERVATION_NOTICE_PERIOD";
    Type["NOTICE_PERIOD_MINIMUM_GREATER_THAN_MAXIMUM"] = "NOTICE_PERIOD_MINIMUM_GREATER_THAN_MAXIMUM";
})(Type || (Type = {}));
export var SortOrder;
(function (SortOrder) {
    /** Soer by ascending order. */
    SortOrder["ASC"] = "ASC";
    /** Sort by descending order. */
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Mode;
(function (Mode) {
    Mode["UNDEFINED"] = "UNDEFINED";
    /** Dry run. */
    Mode["DRY_RUN"] = "DRY_RUN";
    Mode["MIGRATE"] = "MIGRATE";
    Mode["FORCE_MIGRATE"] = "FORCE_MIGRATE";
})(Mode || (Mode = {}));
export var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["PENDING"] = "PENDING";
    State["DEMO"] = "DEMO";
})(State || (State = {}));
export var SiteCreatedContext;
(function (SiteCreatedContext) {
    /** A valid option, we don't expose all reasons why site might be created. */
    SiteCreatedContext["OTHER"] = "OTHER";
    /** A meta site was created from template. */
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    /** A meta site was created by copying of the transfferred meta site. */
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    /** A copy of existing meta site. */
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    /** deprecated A meta site was created for Flash editor. */
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext || (SiteCreatedContext = {}));
export var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
    Namespace["WIX"] = "WIX";
    /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ALBUMS"] = "ALBUMS";
    /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["HOTELS"] = "HOTELS";
    /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["CLUBS"] = "CLUBS";
    /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_SITE"] = "DEV_SITE";
    /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["LOGOS"] = "LOGOS";
    /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    /**
     * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
     *
     * Meta site with this namespace will *not* be shown in a user's site list by default.
     */
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    /**
     * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
     * Will be accessible from Site List and will not have a website app.
     * Once the user attaches a site, the site will become a regular wixsite.
     */
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    /** It is to be used in the Business First efforts. */
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    /** Bookings business flow with no site. */
    Namespace["ANYWHERE"] = "ANYWHERE";
    /** Namespace for Headless Backoffice with no editor */
    Namespace["HEADLESS"] = "HEADLESS";
    /**
     * Namespace for master site that will exist in parent account that will be referenced by subaccounts
     * The site will be used for account level CSM feature for enterprise
     */
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
    /** Rise.ai Siteless account management for Gift Cards and Store Credit. */
    Namespace["RISE"] = "RISE";
    /**
     * As part of the branded app new funnel, users now can create a meta site that will be branded app first.
     * There's a blank site behind the scene but it's blank).
     * The Mobile company will be the owner of this namespace.
     */
    Namespace["BRANDED_FIRST"] = "BRANDED_FIRST";
    /** Nownia.com Siteless account management for Ai Scheduling Assistant. */
    Namespace["NOWNIA"] = "NOWNIA";
    /**
     * UGC Templates are templates that are created by users for personal use and to sale to other users.
     * The Partners company owns this namespace.
     */
    Namespace["UGC_TEMPLATE"] = "UGC_TEMPLATE";
    /** Codux Headless Sites */
    Namespace["CODUX"] = "CODUX";
    /** Bobb - AI Design Creator. */
    Namespace["MEDIA_DESIGN_CREATOR"] = "MEDIA_DESIGN_CREATOR";
    /**
     * Shared Blog Site is a unique single site across Enterprise account,
     * This site will hold all Blog posts related to the Marketing product.
     */
    Namespace["SHARED_BLOG_ENTERPRISE"] = "SHARED_BLOG_ENTERPRISE";
    /** Standalone forms (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["STANDALONE_FORMS"] = "STANDALONE_FORMS";
    /** Standalone events (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["STANDALONE_EVENTS"] = "STANDALONE_EVENTS";
    /** MIMIR - Siteless account for MIMIR Ai Job runner. */
    Namespace["MIMIR"] = "MIMIR";
})(Namespace || (Namespace = {}));
export var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
    DeleteStatus["PURGED_EXTERNALLY"] = "PURGED_EXTERNALLY";
})(DeleteStatus || (DeleteStatus = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var V4DayOfWeek;
(function (V4DayOfWeek) {
    V4DayOfWeek["MONDAY"] = "MONDAY";
    V4DayOfWeek["TUESDAY"] = "TUESDAY";
    V4DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    V4DayOfWeek["THURSDAY"] = "THURSDAY";
    V4DayOfWeek["FRIDAY"] = "FRIDAY";
    V4DayOfWeek["SATURDAY"] = "SATURDAY";
    V4DayOfWeek["SUNDAY"] = "SUNDAY";
})(V4DayOfWeek || (V4DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
/** Determines the reset cycle of the feature usage. */
export var FeaturePeriod;
(function (FeaturePeriod) {
    FeaturePeriod["NO_PERIOD"] = "NO_PERIOD";
    FeaturePeriod["MILLISECOND"] = "MILLISECOND";
    FeaturePeriod["SECOND"] = "SECOND";
    FeaturePeriod["MINUTE"] = "MINUTE";
    FeaturePeriod["HOUR"] = "HOUR";
    FeaturePeriod["DAY"] = "DAY";
    FeaturePeriod["WEEK"] = "WEEK";
    FeaturePeriod["MONTH"] = "MONTH";
    FeaturePeriod["YEAR"] = "YEAR";
})(FeaturePeriod || (FeaturePeriod = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map